"use strict";

module.exports = {
  "-10_signal": "#4ECDC4",
  "-35_signal": "#F7FFF7",
  "3'clip": "#FF6B6B",
  "3'UTR": "#FFE66D",
  "5'clip": "#3E517A",
  "5'UTR": "#BBBBBB",
  "D-loop": "#F13C73",
  allele: "#D86D6D",
  attenuator: "#6B7F9C",
  C_region: "#B5D89D",
  CAAT_signal: "#E9CD98",
  CDS: "#EF6500",
  conserved: "#A3A5F0",
  D_segment: "#C060F7",
  default: "#CCCCCC",
  enhancer: "#38F872",
  exon: "#95F844",
  gap: "#F7D43C",
  GC_signal: "#861F1F",
  gene: "#684E27",
  iDNA: "#A59B41",
  intron: "#52963E",
  J_region: "#369283",
  LTR: "#31748F",
  m_rna: "#FFFF00",
  mat_peptide: "#353E8F",
  misc_binding: "#006FEF",
  misc_difference: "#5A368A",
  misc_feature: "#006FEF",
  misc_marker: "#8DCEB1",
  misc_part: "#006FEF",
  misc_recomb: "#DD97B4",
  misc_RNA: "#BD0101",
  misc_signal: "#FF9A04",
  misc_structure: "#B3FF00",
  modified_base: "#00F7FF",
  mRNA: "#FFD900",
  N_region: "#AE00FF",
  old_sequence: "#F0A7FF",
  operator: "#63004D",
  operon: "#000653",
  oriT: "#580000",
  plasmid: "#00635E",
  polyA_signal: "#BBBBBB",
  polyA_site: "#003328",
  precursor_RNA: "#443200",
  prim_transcript: "#665E4C",
  primer_bind: "#53d969",
  promoter: "#31B440",
  protein_bind: "#2E2E2E",
  protein_domain: "#4D4B4B",
  protein: "#696969",
  RBS: "#BDFFCB",
  rep_origin: "#878787",
  repeat_region: "#966363",
  repeat_unit: "#A16D8D",
  rRNA: "#9BF0FF",
  s_mutation: "#70A2FF",
  S_region: "#FF74A9",
  satellite: "#164E64",
  scRNA: "#A057FF",
  sig_peptide: "#2FFF8D",
  snoRNA: "#296B14",
  snRNA: "#A16249",
  source: "#0B17BD",
  start: "#D6A336",
  stem_loop: "#67069E",
  stop: "#D44FC9",
  STS: "#597FE7",
  tag: "#E419DA",
  TATA_signal: "#EB2B2B",
  terminator: "#F51600",
  transit_peptide: "#24D491",
  transposon: "#B6E436",
  tRNA: "#D1456F",
  V_region: "#7B5EE7",
  variation: "#2EE455"
};